import React, { useState, useEffect } from 'react';
import { IonModal, IonButton, IonSpinner } from '@ionic/react';
import billingService from '../../../../services/billing';
import './CouponModal.css';

/**
 * Coupon entry modal — visually identical to the "Connect GitLab" modal
 * (same IonModal + gitlab-* class names defined in IntegrationsPage.css).
 */
const CouponModal = ({ isOpen, onDismiss, onApplied }) => {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  // Reset on open
  useEffect(() => {
    if (isOpen) {
      setCode('');
      setError('');
      setSubmitting(false);
    }
  }, [isOpen]);

  const submit = async () => {
    const trimmed = code.trim();
    if (!trimmed || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await billingService.applyCoupon(trimmed);
      if (typeof onApplied === 'function') onApplied(res);
      onDismiss();
    } catch (err) {
      setError(err?.message || err?.data?.error || 'Could not apply coupon');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      className="gitlab-connect-modal"
    >
      <div className="gitlab-modal-content">
        <h2>Apply coupon</h2>
        <p className="gitlab-modal-description">
          Enter a Stripe promotion or coupon code. The discount applies to your existing subscription and any future invoices.
        </p>

        <div className="gitlab-form-group">
          <label className="gitlab-form-label">Coupon code</label>
          <input
            type="text"
            value={code}
            placeholder="e.g. INTERNAL2026"
            onChange={(e) => { setCode(e.target.value || ''); setError(''); }}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            className="gitlab-form-input"
            disabled={submitting}
            autoFocus
            maxLength={64}
          />
        </div>

        {error && <p className="gitlab-modal-error">{error}</p>}

        <div className="gitlab-modal-buttons">
          <IonButton
            expand="block"
            onClick={submit}
            disabled={submitting || !code.trim()}
          >
            {submitting ? <IonSpinner name="crescent" /> : 'Apply'}
          </IonButton>
          <IonButton
            expand="block"
            fill="clear"
            onClick={onDismiss}
            disabled={submitting}
          >
            Cancel
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default CouponModal;
